var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","nudge-bottom":3,"content-class":_vm.contentClasses},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("activator",null,{"attrs":attrs,"on":{
        mouseenter: (e) => _vm.onTooltip(e, on.mouseenter),
        mouseleave: (e) => _vm.onTooltip(e, on.mouseleave),
        focus: (e) => _vm.onTooltip(e, on.focus),
        blur: (e) => _vm.onTooltip(e, on.blur),
        keydown: (e) => _vm.onTooltip(e, on.keydown),
      }})]}}],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }